import { render, staticRenderFns } from "./ChatMemberCard.vue?vue&type=template&id=29e5e472&"
import script from "./ChatMemberCard.vue?vue&type=script&lang=ts&"
export * from "./ChatMemberCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports